import React, {useState, useEffect, useRef} from 'react';
import './index.scss';
import DataGrid, {
    Column,
    Pager,
    Paging,
    FilterRow,
    Scrolling,
    Selection,
    MasterDetail,
    Editing
} from 'devextreme-react/data-grid';
import { CheckBox } from 'devextreme-react/check-box';
import {Button} from 'devextreme-react/button';
import {DropDownButton} from 'devextreme-react/drop-down-button';
import {Popup, ToolbarItem} from 'devextreme-react/popup';
import ScrollView from 'devextreme-react/scroll-view';
import { Tooltip } from 'devextreme-react/tooltip';
import GenerateMultipleLabel from './multiple-label/multiple-label';
import NewOrder from './new-orders/new-order';
import ActionButtons from '../../utils/button-action/button-actions';
import url from '../../api/base-url';
import DataSource from 'devextreme/data/data_source';
import MasterDetails from './master-details/index';
import Notes from './orders-note/orders-note';
import ExportDialog from './export-dialog/export-dialog'
import ImportDialog from './import-dialog/import-dialog'
import OrderDetailsEdit from './order-details-edit/index';
import OrderDetailsView from './order-details-view/index';
import manualOrdersIcon from '../../assets/shipsland.png';
import amazonIcon from '../../assets/amazon_icon.png';
import ebayIcon from '../../assets/ebay_icon.png';
import etsyIcon from '../../assets/etsy_icon.png';
import shopifyIcon from '../../assets/shopify_logo.png';
import orderApi from '../../api/order';
import shipmentApi from '../../api/shipment'
import addressApi from '../../api/address';
import CreatePackingSlip from './create-packing-slip/index';
import MarksAsShipped from './mark-as-shipped/index';
import ViewSDKClient from '../../components/adobe-dc/ViewSDKClient';
import sessions from '../../sessions';
import notify from 'devextreme/ui/notify';
import {createStore} from "devextreme-aspnet-data-nojquery";
import 'whatwg-fetch';

export default function Orders(props) {
    const store = props.store?props.store: '';
    const storeName = window.location.href.split("/")[7];
    const status = props.status;
    const [isPopUpVisible, setIsPopUpVisible] = useState(false);
    const [isPreviewPackingSlipVisible, setPreviewPackingSlipVisible] = useState(false);
    const [data,setData] = useState('');
    const [selectedRows,setSelectedRows] = useState([]);
    const [currentSelectedRowKey,setCurrentSelectedRowKey] = useState();
    const [activateButtonActions,setActivateButtonActions] = useState(false);
    const [isInternalNote,setIsInternalNote] = useState(false);
    const [isExportDialog,setIsExportDialog] = useState(false);
    const [isImportDialog,setIsImportDialog] = useState(false);
    const [isNoteFromBuyer,setIsNoteFromBuyer] = useState(false);
    const [isNoteToBuyer,setIsNoteToBuyer] = useState(false);
    const [isOrderDetailsEdit, setIsOrderDetailsEdit] = useState(false);
    const [isOrderDetailsView, setIsOrderDetailsView] = useState(false);
    const [isMarksAsShipped, setIsMarksAsShipped] = useState(false);
    const [isRefresh, setIsrefresh] = useState(false);
    const [isGenerateMultipleLabel, setIsGenerateMultipleLabel] = useState(false);
    const [showName, setShowName] = useState(true);
    const [showAge, setShowAge] = useState(true);
    const [showCity, setShowCity] = useState(true);
    const [showState, setShowState] = useState(true);
    const [showZipCode, setShowZipCode] = useState(true);
    const [showCountry, setShowCountry] = useState(true);
    const [showStore, setShowStore] = useState(true);
    const [showPaidDate, setShowPaidDate] = useState(true);
    const [showShipDate, setShowShipDate] = useState(true);
    const [showShippingPaid, setShowShippingPaid] = useState(true);
    const [showTaxPaid, setShowTaxPaid] = useState(true);
    const [showTotalPaid, setShowTotalPaid] = useState(true);
    const [showQuantity, setShowQuantity] = useState(true);

    const childRef = useRef();
    const childRefPackingSlip = useRef();
    const exportDataRef = useRef();
    const importDataRef = useRef();
    const InternalNoteRef = useRef();
    const NoteFromBuyerRef = useRef();
    const NoteToBuyerRef = useRef();
    const masRef = useRef();
    const gmlRef = useRef();
    const orderDetailEditRef = useRef();

    const userId = sessions.getSession("user")?.id;
    const auth = sessions.getSession("user")?.accessToken;
    const GridRef = useRef();
    var Grid = null;
    var dataGrid = null;

    useEffect(() => {
        setData(ActionButtons(status));
    }, [status]);

    useEffect(() => {
        Grid = GridRef.current.instance;
        dataGrid = GridRef.current.instance;
    })

    function getConfig(options) {  
        options.onBeforeSend = function(method, ajaxOptions) {  
            ajaxOptions.headers = {  
               "x-access-token": auth
            }  
        }  
        return options;  
    };

    const AllOrdersDataSource = createStore(getConfig({
        key: '_id', 
        loadUrl: `${url}/orders/${store?store:'all'}/${storeName}/${status}/${userId}`
    }));

    // for date get from
    // https://stackoverflow.com/questions/19225414/how-to-get-the-hours-difference-b
    // etween-two-date-objects/19225463
    const inHours = (d1, d2) => {
        var t2 = new Date(d2).getTime();
        var t1 = new Date(d1).getTime();
        return Math.floor(Math.abs(t2 - t1) / 36e5);
    };

    const inDays = (d1, d2) => {
        var t2 = new Date(d2).getTime();
        var t1 = new Date(d1).getTime();
        return Math.abs(parseInt((t2 - t1) / (24 * 3600 * 1000)));
    };

    const inWeeks = (d1, d2) => {
        var t2 = new Date(d2).getTime();
        var t1 = new Date(d1).getTime();
        return Math.abs(parseInt((t2 - t1) / (24 * 3600 * 1000 * 7)));
    };

    const inMonths = (d1, d2) => {
        var d1Y = new Date(d1).getFullYear();
        var d2Y = new Date(d2).getFullYear();
        var d1M = new Date(d1).getMonth();
        var d2M = new Date(d2).getMonth();
        return (d2M + 12 * d2Y) - (d1M + 12 * d1Y);
    };

    const inYears = (d1, d2) => {
        return new Date(d2).getFullYear() - new Date(d1).getFullYear();
    };

    const batchNo = (data) =>{
        var value =data?.batchNo;
        var status = data?.status;
        if(status === 'shipped' || status === 'on-hold'){
            if(value)
                return `Batch-${value}`;
            else
                return '';
        }
        else   
            return '';
    };

    const calculateCellValue = (data) => {
        const now = new Date();
        const dataCreated = data?.orderDate?.toLocaleString()
        var hours = inHours(now, dataCreated);
        var days = inDays(now, dataCreated);
        var weeks = inWeeks(now, dataCreated);
        var months = inMonths(now, dataCreated);
        var years = inYears(now, dataCreated);

        const result = hours;
        if (result >= 24) {
            return days + " d";
        } else if (result >= 168) {
            return weeks + " w";
        } else if (result >= 720) {
            return months + " m";
        } else if (result >= 8640) {
            return years + " y";
        } else 
            return hours + " h";
    }

    const calcShippingPaid = (data) => {
        var value = data.shippingPaid?data.shippingPaid:0;
        var curr = data?.currency?data.currency:'USD';
        var currency = addressApi.getSymbolbyCurrencyName(curr);
        return `${currency}${value}`;
    }

    const calcTaxPaid = (data) => {
        var value = data.taxPaid?data.taxPaid:0;
        var curr = data?.currency?data.currency:'USD';
        var currency = addressApi.getSymbolbyCurrencyName(curr);
        return `${currency}${value}`;
    }

    const calcOrderTotal = (data) => {
        var value = data.totalPaid?data.totalPaid:0;
        var curr = data?.currency?data.currency:'USD';
        var currency = addressApi.getSymbolbyCurrencyName(curr);
        return `${currency}${value}`;
    }
    const cancelButton = {
        text: 'cancel',
        onClick: () => setIsPopUpVisible(false)
    }

    const saveButton = {
        text: 'save',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: (e) => childRef
            .current
            .saveOnClick(e)
    }

    const cancelMASButton = {
        text: 'cancel',
        onClick: () => setIsMarksAsShipped(false)
    }

    const saveMSASButton = {
        text: 'save',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: (e) => masRef
            .current
            .saveOnClick(e)
    }

    const InternalNoteBtn = {
        text: 'save',
        useSubmitBehavior: true,
        onClick: (e) => InternalNoteRef
            .current
            .saveOnClick(e)
    }

    const internalNoteCancelButton = {
        text: 'cancel',
        onClick: () => setIsInternalNote(false)
    }

    const exportCancelButton = {
        text: 'cancel',
        onClick: () => setIsExportDialog(false)
    }

    const importCancelButton = {
        text: 'cancel',
        onClick: () => setIsImportDialog(false)
    }

    const importButton = {
        text: 'import',
        useSubmitBehavior: true,
        onClick: (e) => importDataRef
            .current
            .handleSubmit()
    }    

    const exportButton = {
        text: 'export',
        useSubmitBehavior: true,
        onClick: (e) => exportDataRef
            .current
            .exportDataAct()
    }    

    const DetailEditCancelButton = {
        text: 'cancel',
        useSubmitBehavior: true,
        onClick: () => setIsOrderDetailsEdit(false)
    }

    const DetailEditSaveButton = {
        text: 'save',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: (e) => orderDetailEditRef
            .current
            .saveOnClick(e)
    }

    const DetailViewCancelButton = {
        text: 'cancel',
        useSubmitBehavior: true,
        onClick: () => setIsOrderDetailsView(false)
    }

    const NoteFromBuyerBtn = {
        text: 'save',
        useSubmitBehavior: true,
        onClick: (e) => NoteFromBuyerRef
            .current
            .saveOnClick(e)
    }

    const NoteFromBuyerCancelButton = {
        text: 'cancel',
        onClick: () => setIsNoteFromBuyer(false)
    }

    const NoteToBuyerBtn = {
        text: 'save',
        useSubmitBehavior: true,
        onClick: (e) => NoteToBuyerRef
            .current
            .saveOnClick(e)
    }

    const NoteToBuyerCancelButton = {
        text: 'cancel',
        onClick: () => setIsNoteToBuyer(false)
    }

    const saveGmlButton = {
        text: 'Print Packing Slips',
        useSubmitBehavior: true,
        validationGroup: 'group',
        onClick: (e) => gmlRef
        .current
        .saveOnClick(e)
    };

    const cancelGmlButton = {
        text: 'cancel',
        useSubmitBehavior: true,
        onClick: () => setIsGenerateMultipleLabel(false)
    };

    const closeInternalPopUpClick  = () => {
        setIsInternalNote(false);
    }

    const closeNoteFromBuyerPopUpClick = () =>{
        setIsNoteFromBuyer(false);
    }
    
    const closeNoteToBuyerPopUpClick = () =>{
        setIsNoteToBuyer(false);
    }

    const closeExportPopUpClick = () => {
        setIsExportDialog(false);
    }
    
    const capitalize = (s) => {
        return s
            ?.toLowerCase()
            ?.replace(/\b./g, function (a) {
                return a.toUpperCase();
            });
    };

    const itemTemplateRender = (item) => {
        //console.log("otheraction",item);
        const itemsStyle = {
            fontSize: '13px',
            margin: 0
        };
        return (
            <div id="view-pdf-btn" style={itemsStyle}>{item}</div>
        );
    }

    const onSelectionChanged = (e) => {
        const hasSelection = e.component.option('selectionFilter') === null || e.component.option('selectionFilter').length > 0;  
        if(hasSelection){  
            setActivateButtonActions(true);       
        }else{
            setActivateButtonActions(false);
        }
    }

    const ColumnTemplateRender = (item) => {
        //console.log("item",item);
        const itemsStyle = {fontSize: '13px',margin: 0}
        return(
            <div style={itemsStyle}>
            <CheckBox defaultValue={true} text={item}/>
            </div>
        );
    }

    const onInitialized = (e) => {
        Grid = e
        dataGrid = e.component;
    }

    const onHoldButton = () => {
        var orderIDs = [];
        dataGrid.getSelectedRowsData().then(async(selectedRows)=>{
            var isShopify = false;
            console.log(selectedRows);
            selectedRows.map((item, index) => {
                if(item.store === 'shopify') {
                    isShopify=true; 
                }else{
                    orderIDs.push(item._id);
                }
            })
            if(isShopify){
                notify('Cant on hold shopify order', "error", 5000);
            }else{
                await shipmentApi.markAsOnHold(userId, orderIDs,auth).then((res) => {
                if (res.data.success === true) {
                    notify(res.data.message, "success", 2000);
                } else {
                    notify(res.data.message, "error", 2000);
                }     
            })     
            }
            console.log('instanceGrid', Grid)
            await dataGrid.deleteRow(orderIDs)
        });
    }

    const markAsPaidButton = () => {
        dataGrid.getSelectedRowKeys().then((selectedRowKeys)=>{
            shipmentApi.markAsPaid(userId, selectedRowKeys,auth)
            .then((res) => {
                console.log('res', res)
                if (res.data.success === true) {
                    notify(res.data.message, "success", 2000);
                } else {
                    notify(res.data.message, "warning", 2000);
                }                
            })
        });
    }

    const cancelOrder = () =>{
        dataGrid.getSelectedRowKeys().then(async(selectedRowKeys)=>{
        await shipmentApi.markAsCancel(userId, selectedRowKeys,auth)
        .then((res)=>{
            if (res.data.success === true) {
                notify(res.data.message, "success", 2000);
                setIsrefresh(true);
            }
        }).catch(err=>{
            setIsrefresh(true);
            if(err.message.includes("404"))
                notify("please try again later", "error", 500);
                setIsrefresh(true);
        })
        })
    }

    const exportOrderOnClick = () =>{
        setIsExportDialog(true);
        Grid = GridRef.current.instance;
        dataGrid.getSelectedRowsData().then(rowData=>{setSelectedRows(rowData)})
    }
    const OtherActionsItemOnClick = (e) => {
        const item = e.itemData;
        //notify(item, 'success', 600);
        //console.log(item)
        switch (item) {
            case 'Export Orders':
                exportOrderOnClick();break;
            case 'Import Orders':
                setIsImportDialog(true)
                break;
            case 'Cancel':
                cancelOrder();
                break;
            default:
                return '';

        }
    }

    const columnsCustomiseOnClick = (e) => {
        const item = e.itemData;
        if (item === 'age') return setShowAge(!showAge)
        else if (item === 'name') return setShowName(!showName)
        else if (item === 'orderNo') return setShowName(!showName)
        else if (item === 'city') return setShowCity(!showCity)
        else if (item === 'state') return setShowState(!showState)
        else if (item === 'zipCode') return setShowZipCode(!showZipCode)
        else if (item === 'country') return setShowCountry(!showCountry)
        else if (item === 'country') return setShowCountry(!showCountry)
        else if (item === 'store') return setShowStore(!showStore)
        else if (item === 'paidDate') return setShowPaidDate(!showPaidDate)
        else if (item === 'shipDate') return setShowShipDate(!showShipDate)
        else if (item === 'shippingPaid') return setShowShippingPaid(!showShippingPaid)
        else if (item === 'taxPaid') return setShowTaxPaid(!showTaxPaid)
        else if (item === 'totalPaid') return setShowTotalPaid(!showTotalPaid)
        else if (item === 'quantity') return setShowQuantity(!showQuantity)
        else return false
    }
    
    const totalQuantity = (data) => {
        const items = data.value;
        var countQty = 0;
        if(items){
            items.map(item => {return(countQty +=parseInt(item.quantity,10))})
            return(<div>{countQty}</div>)
        }
    }

    const currencyFormat =  { style: 'currency', currency: 'USD', useGrouping: true, minimumSignificantDigits: 3 };
    
    const orderRender = (data) => {
        var value = data.data;
        var orderNo = value.orderNo;
        return(
            <span>#{orderNo}</span>
        );
    }

    const orderRenderForAll = (data) => {
        var value = data.data;
        var orderNo = value.orderNo;
        var status = value.status;
        var store = value.store;
        var storeName = value.storeName?value.storeName:value.store;

        if(store?.includes('Manual Orders')){
            return (
                <div id={'order-render'} className={'flex flex-row'}>
                    <span className={'store m_2'}>
                        <img alt={store} className={'store-icon'} src={manualOrdersIcon}/>
                    </span>
                    <span className={'m_2'}>
                        <p>#{orderNo}</p>
                        <div className={'orderRender-status store-name-manual-order'}>
                            <span className={'blue-circle'}></span>
                            <p>{storeName}</p>
                        </div>
                    </span>
                </div>
                ) 
        }
        else if(store?.includes('ebay')){
            return (
                <div id={'order-render'} className={'flex flex-row'}>
                    <span className={'store m_2'}>
                        <img alt={store} className={'store-icon'} src={ebayIcon}/>
                    </span>
                    <span className={'m_2'}>
                        <p>#{orderNo}</p>
                        <div className={'orderRender-status store-name-ebay'}>
                            <span className={'pink-red-circle'}></span>
                            <p>{storeName}</p>
                        </div>
                    </span>
                </div>
            )
        }
        else if(store?.includes('etsy')){
            return (
                <div id={'order-render'} className={'flex flex-row'}>
                    <span className={'store m_2'}>
                        <img alt={store} className={'store-icon'} src={etsyIcon}/>
                    </span>
                    <span className={'m_2'}>
                        <p>#{orderNo}</p>
                        <div className={'orderRender-status store-name-etsy'}>
                            <span className={'orange-circle'}></span>
                            <p>{storeName}</p>
                        </div>
                    </span>
                </div>
            )
        }  
        else if(store?.includes('shopify')){
            return (
                <div id={'order-render'} className={'flex flex-row'}>
                    <span className={'store m_2'}>
                        <img alt={store} className={'store-icon'} src={shopifyIcon}/>
                    </span>
                    <span className={'m_2'}>
                        <p>#{orderNo}</p>
                        <div className={'orderRender-status store-name-shopify'}>
                            <span className={'green-circle'}></span>
                            <p>{storeName}</p>
                        </div>
                    </span>
                </div>
            )
        } else if(store?.includes('amazon')){
            return (
                <div id={'order-render'} className={'flex flex-row'}>
                    <span className={'store m_2'}>
                        <img alt={store} className={'store-icon'} src={amazonIcon}/>
                    </span>
                    <span className={'m_2'}>
                        <p>#{orderNo}</p>
                        <div className={'orderRender-status store-name-amazon'}>
                            <span className={'black-circle'}></span>
                            <p>{storeName}</p>
                        </div>
                    </span>
                </div>
            )
        }
        else
            return (<span> {capitalize(store)} </span>)

    };

    const customerRender = (data) => {
        var i=data.rowIndex;
        var value = data.data;
        var name = value.name;
        var iso2 = value.country;
        var city = value.city;
        var zipCode = value.zipCode;
        var isAddressValid = value.addressVerified;
        var Address = (props)=>{
            const country = props.country;
            if(country === 'US'){
                if(isAddressValid)
                    return (<i id={`validAddress${i}`} type="success" className={`fas fa-check-circle`} style={{fontSize:'12px',color:'green'}}/>);
                else
                    return (<i id={`invalidAddress${i}`} type="error" className={`fas fa-exclamation-circle`} style={{fontSize:'12px',color:'red'}}/>);
            }
            else{
                return (<i id={`intlAddress${i}`} className={`fas fa-globe-europe`} style={{fontSize:'12px'}}/>);
            }
        };

        return(
            <div className={'customer'}>
                <div className={'flag'}>
                   <img className={'emoji-flag'} alt={iso2} src={`https://purecatamphetamine.github.io/country-flag-icons/3x2/${iso2}.svg`}/>
                </div>
                <div className={'flex flex-column'} style={{margin:'0 5px'}}>
                    <span><b>{name}</b></span>
                    <span style={{fontSize:'11px'}}>{city} , {zipCode} 
                        <Address country={iso2}/>
                    </span>
                </div>
                <Tooltip
                       target={`#validAddress${i}`}
                       showEvent="dxhoverstart"
                       hideEvent="dxhoverend"
                       closeOnOutsideClick={false}
                     >
                       <div>valid address</div>
                </Tooltip>
                <Tooltip
                       target={`#invalidAddress${i}`}
                       showEvent="dxhoverstart"
                       hideEvent="dxhoverend"
                       closeOnOutsideClick={false}
                >
                       <div>invalid address</div>
                </Tooltip>
                <Tooltip
                       target={`#intlAddress${i}`}
                       showEvent="dxhoverstart"
                       hideEvent="dxhoverend"
                       closeOnOutsideClick={false}
                >
                       <div>international address</div>
                </Tooltip>
            </div>
        );
    }

    const closeImportDialog = () => {
        setIsImportDialog(false)
    }

    const PrintItemOnClick = (e) => {
        if((e.itemData.name || e.itemData) === 'Packing Slip'){
            dataGrid.getSelectedRowKeys().then(async(selectedRowKeys)=>{
                const result = await orderApi.generatePdf(selectedRowKeys,auth);
                var orderId = result.data.data;
                await orderApi.fetchPackingSlips(orderId).then(res => {
                    const pdfBlob = new Blob([res.data], { type: 'application/pdf' })
                    var url = window.URL.createObjectURL(pdfBlob);
                    
                    const viewSDKClient = new ViewSDKClient();
                    viewSDKClient.ready().then(() => {
                        viewSDKClient.previewFile({embedMode: "LIGHT_BOX"},"",url,"Preview");
                    });
                });
            })
        }
    }

    const gmlOnClick = () =>{
        dataGrid.getSelectedRowsData().then(selectedRows=>{
            setSelectedRows(selectedRows);
            setIsGenerateMultipleLabel(true);
        });
    }

    const markAsShippedOnClick = () =>{
        dataGrid.getSelectedRowsData().then(rowData=>{
            setSelectedRows(rowData);
            setIsMarksAsShipped(true);
        });
        
    }

    const title = (status,store,storeName) => {
        if(!store){
            return(<div><h4 className={'mb-2'}>{capitalize(status)}</h4></div>);
        }else{
            if(storeName){
                switch(store){
                    case 'ebay':
                        return (
                            <h4 className={'mb-2'}>
                                <img alt={store} className={'title-icon'} src={ebayIcon}/>
                                {capitalize(storeName)}
                            </h4>)
                    case 'etsy':
                        return (
                            <h4 className={'mb-2'}>
                                <img alt={store} className={'title-icon'} src={etsyIcon}/>
                                {capitalize(storeName)}
                            </h4>)
                    case 'shopify':
                        return (
                            <h4 className={'mb-2'}>
                            <img alt={store} className={'title-icon'} src={shopifyIcon}/>
                            {capitalize(storeName)}
                        </h4>)
                    case 'amazon':
                        return (
                            <h4 className={'mb-2'}>
                            <img alt={store} className={'title-icon'} src={amazonIcon}/>
                            {capitalize(storeName)}
                    </h4>)
                    default:
                        return (<h4>storeName</h4>);
                }
            }else{
                return (
                    <div><h4 className={'mb-2'}>{capitalize(store)}</h4></div>
                )
            }
        }
        
    };
    return (
        <React.Fragment>
           <div id={'order-content'}>
            {title(status,store,storeName)}
            <Popup id="previewPackingSlip"
                Title = {"Packing Slip"}
                visible={isPreviewPackingSlipVisible}
                onHiding={e => setPreviewPackingSlipVisible(false)}>
                <CreatePackingSlip ref={childRefPackingSlip}/>
            </Popup>     
            <Popup id="exportPopUp"
                visible={isExportDialog}
                onHiding={e => {setIsExportDialog(false)}}
                showTitle={true}
                title= "Export Orders"
                width={600}>
                <ExportDialog dataExport={Grid} selectedRowsData={selectedRows} ref={exportDataRef} />
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={exportCancelButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={exportButton}></ToolbarItem>
            </Popup>                           
            <Popup id="importPopUp"
                visible={isImportDialog}
                onHiding={e => {setIsImportDialog(false)}}                
                showTitle={true}
                title= "Import Orders"
                width={600}>
                <ImportDialog ref={importDataRef} closeImportDialog={closeImportDialog} />
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={importButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={importCancelButton}></ToolbarItem>
            </Popup>                                       
            <Popup id="newOrderPopUp"
                title="New Order"
                visible={isPopUpVisible}
                onHiding={e => setIsPopUpVisible(false)}>
                <NewOrder ref={childRef} isClick={true}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={saveButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={cancelButton}></ToolbarItem>
            </Popup>
            <Popup id="OrderDetailsEditPopUp"
                title={'Order Details'}
                visible={isOrderDetailsEdit}
                onHiding={e => {setIsOrderDetailsEdit(false)}}>
                <OrderDetailsEdit ref={orderDetailEditRef} data = {selectedRows}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={DetailEditSaveButton}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={DetailEditCancelButton}></ToolbarItem>
            </Popup>
            <Popup id="OrderDetailsViewPopUp"
                title={'Order Details'}
                visible={isOrderDetailsView}
                onHiding={e => setIsOrderDetailsView(false)}>
                    <OrderDetailsView data = {selectedRows}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={DetailViewCancelButton}></ToolbarItem>
            </Popup>
            <Popup id="InternalNotesPopUp"
                visible={isInternalNote}
                onHiding={e => {setIsInternalNote(false)}}
                showTitle={true}
                title= "Internal Note"
                width={300}
                height={250}>
                <Notes ref={InternalNoteRef} id={currentSelectedRowKey} notes={'1'} close={closeInternalPopUpClick} />
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={InternalNoteBtn}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={internalNoteCancelButton}></ToolbarItem>
            </Popup>
            <Popup id="NotesFromPopUp"
                visible={isNoteFromBuyer}
                onHiding={e => {setIsNoteFromBuyer(false)}}
                showTitle={true}
                title= "Note From Buyer"
                width={300}
                height={250}>
                <Notes ref={NoteFromBuyerRef} id= {currentSelectedRowKey} notes={'2'} close={closeNoteFromBuyerPopUpClick}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={NoteFromBuyerBtn}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={NoteFromBuyerCancelButton}></ToolbarItem>
            </Popup>
            <Popup id="NotesToPopUp"
                visible={isNoteToBuyer}
                onHiding={e => {setIsNoteToBuyer(false)}}
                showTitle={true}
                title= "Note To Buyer"
                width={300}
                height={250}>
                <Notes ref={NoteToBuyerRef} id= {currentSelectedRowKey} notes={'3'} close={closeNoteToBuyerPopUpClick}/>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={NoteToBuyerBtn}></ToolbarItem>
                <ToolbarItem
                    widget="dxButton"
                    location="after"
                    toolbar='bottom'
                    options={NoteToBuyerCancelButton}></ToolbarItem>
            </Popup>
            <Popup id="MarkAsShippedPopUp"
                 visible={isMarksAsShipped}
                 onHiding={e => {setIsMarksAsShipped(false)}}
                 showTitle={true}
                 title= "Mark Order as Shipped"
                 >
                     <ScrollView>
                        <MarksAsShipped ref={masRef} data = {selectedRows}/>
                     </ScrollView>
                 <ToolbarItem
                     widget="dxButton"
                     location="after"
                     toolbar='bottom'
                     options={saveMSASButton}></ToolbarItem>
                 <ToolbarItem
                     widget="dxButton"
                     location="after"
                     toolbar='bottom'
                     options={cancelMASButton}></ToolbarItem>
            </Popup>
            <Popup id="generate-multiple-label"
                 visible={isGenerateMultipleLabel}
                 onHiding={e => {setIsGenerateMultipleLabel(false)}}
                 showTitle={true}
                 title= "Batch Shipments"
                 width={'50vw'}
                 >
                     <ScrollView>
                        <GenerateMultipleLabel ref={gmlRef} data = {selectedRows}/>
                     </ScrollView>
                 <ToolbarItem
                     widget="dxButton"
                     location="after"
                     toolbar='bottom'
                     options={saveGmlButton}></ToolbarItem>
                 <ToolbarItem
                     widget="dxButton"
                     location="after"
                     toolbar='bottom'
                     options={cancelGmlButton}></ToolbarItem>
            </Popup>
            <div className={'action-buttons'}>
                {status === 'awaiting-shipment'
                    ? <Button
                        className="m-2"
                        type="normal"
                        disabled={!activateButtonActions}
                        text="Batch Shipments"
                        onClick = {gmlOnClick}/>
                    : ''}
                {status === 'awaiting-shipment'
                    ? <Button
                            className="m-2"
                            type="normal"
                            disabled={!activateButtonActions}
                            text="mark as shipped"
                            onClick = {markAsShippedOnClick}/>
                    : ''}
                {status === 'awaiting-shipment'
                    ? <Button
                            className="m-2"
                            type="normal"
                            disabled={!activateButtonActions}
                            text="on hold"
                            onClick = {onHoldButton}/>
                    : ''}
                <DropDownButton
                    stylingMode={'contained'}
                    disabled={!activateButtonActions}
                    className="m-2"
                    text="Print"
                    dropDownOptions={{
                    width: 150
                }}
                    items={data.print}
                    itemRender={itemTemplateRender}
                    onItemClick={PrintItemOnClick}/>
                <Button
                    className="m-2"
                    type="normal"
                    text="import order" onClick={()=>{setIsImportDialog(true)}}/>
                <Button
                    className="m-2"
                    text="New Order"
                    onClick={e => setIsPopUpVisible(true)}/> {status === 'awaiting-payment'
                    ? <Button
                            className="m-2"
                            type="default"
                            disabled={!activateButtonActions}
                            onClick={markAsPaidButton}
                            text="Marked As Paid"/>
                    : ''}
                {status === 'on-hold'
                    ? <Button
                            className="m-2"
                            type="default"
                            disabled={!activateButtonActions}
                            text="Remove Hold"/>
                    : ''}
                <DropDownButton
                    stylingMode={'contained'}
                    disabled={!activateButtonActions}
                    className= {'m-2'}
                    text="Other Actions"
                    dropDownOptions={{
                        width: 200,
                        height: 100,
                        overflowY: 'auto'
                }}
                    items={data.otherActions}
                    itemRender={itemTemplateRender}
                    onItemClick={OtherActionsItemOnClick}/>
                <DropDownButton
                    id={'customize-columns'}
                    stylingMode={'contained'}
                    disabled={!activateButtonActions}
                    visible={false }
                    className={'m-2'}
                    text="Customize Columns"
                    dropDownOptions={{
                    width: 200,
                    height: 250,
                    overflowY: 'auto'
                }}
                    items = {data.columnCustomize}
                    itemRender={ColumnTemplateRender}
                    onItemClick={columnsCustomiseOnClick}/>
            <br/>
            </div>
            <div id={'grid-area'} className={'flex-row'}>
                <div className={'data-grid'}>
                 <DataGrid id={'order-datagrid'}
                 className={'dx-card wide-card'}
                 dataSource={AllOrdersDataSource}
                 showBorders={false}
                 allowColumnReordering={true}
                 allowColumnResizing={true}
                 columnAutoWidth={false}
                 columnHidingEnabled={true}
                 focusedRowEnabled={false}
                 noDataText={(store === '' || store === undefined)
                 ? `You have no orders in ${status}`
                 : 'no data in the grid'}
                 ref={GridRef}
                 hoverStateEnabled={true}
                 onSelectionChanged={onSelectionChanged}
                 onInitialized={onInitialized}
                 >
                <Scrolling rowRenderingMode="virtual"/>
                <Paging defaultPageSize={5}/>
                 <Pager showPageSizeSelector={true} showInfo={true}/>
                 <FilterRow visible={true}/>
                 <Selection mode="multiple" allowSelectAll={true} deferred={true} selectAllMode={'AllPages'}/>
                 <Editing mode="form" allowUpdating={true} />
                 <Column dataField={'actions'} type="buttons" width={110}
                 buttons={[{
                     icon:'fa fa-eye',
                     hint: 'view order',
                     type: 'normal',
                     onClick: (e) => {setIsOrderDetailsView(true);setSelectedRows(e?.row?.data)}
                 },
                 {
                    icon:'edit',
                    hint: 'edit order',
                    onClick: (e) => {setIsOrderDetailsEdit(true);setSelectedRows(e?.row?.data)}
                 }]}/>
                 {store?
                  <Column dataField={'orderNo'} caption="Order" cellRender={orderRender} width={150}/>
                  : <Column dataField={'orderNo'} caption="Order" cellRender={orderRenderForAll} width={150}/>
                 }
                 <Column dataField={'name'} caption="Customer" cellRender={customerRender} width={170}/>
                 <Column dataField={'orderDate'} caption={'Age'} calculateCellValue={calculateCellValue}/>
                 <Column dataField={'sku'} dataType="number" caption="Quantity" cellRender={totalQuantity}/>
                 <Column dataField={'totalPaid'} caption="Order Total"  calculateCellValue = {calcOrderTotal} />
                 <Column dataField={'notes'} type="buttons" width={110}
                 buttons={[{
                    hint: 'Internal Note',
                    icon: 'far fa-sticky-note',
                    onClick: (e)=> {setCurrentSelectedRowKey(e?.row?.key);setIsInternalNote(true)}
                  },{
                    hint: 'Note From Buyer',
                    icon: 'user',
                    onClick: (e)=> {setCurrentSelectedRowKey(e?.row?.key);setIsNoteFromBuyer(true)}
                },{
                    hint: 'Note To Buyer',
                    icon: 'far fa-comment',
                    onClick: (e)=> {setCurrentSelectedRowKey(e?.row?.key);setIsNoteToBuyer(true)}
                }]} 
                 />
                <Column dataField={'batchNo'} calculateCellValue={batchNo}/>
                <Column dataField={'paidDate'} dataType="date" caption="Paid Date" />
                 <Column dataField={'shipDate'} dataType="date" />
                 <Column dataField={'shippingPaid'}  calculateCellValue = {calcShippingPaid}/>
                 <Column dataField={'taxPaid'}  calculateCellValue = {calcTaxPaid}/>
                <MasterDetail className={'master-detail-caption'} enabled={true} component={MasterDetails} />
                </DataGrid>
                </div>
            </div>
           </div>
        </React.Fragment>
    );
}
